const Palette = {
  Argent: "#D3D5D0",
  Ashen: "#76716E",
  Pitch: "#1A1713",
  Shadow: "#231F1A",

  Gray1: "#99928E",
  Gray2: "#CCC3BE",

  Sand1: "#80715E",
  Sand2: "#E6CCAA",
  Rose1: "#805D63",
  Rose2: "#E6A8B2",
  Vitae1: "#6C807E",
  Vitae2: "#C3E6E3",

  Evoke1: "#805D7E",
  Evoke2: "#E6A8E3",

  Plaster1: "#F1DD8A",
  Plaster2: "#C2B791",

  Ochre1: "#E96900",
  Ochre2: "#E89B5D",

  Rouge1: "#992103",
  Rouge2: "#E6775C",

  Copper1: "#994500",
  Copper2: "#99673D",

  Farmlet: {
    DoorPaint: "#277F4F",
    DoorTrim: "#754524",
    Whitewash: "#E2DCC1",
    Daub: "#89785C",
    Floor2: "#806D61",
    Floor1: "#664E3D",
    Tabletop: "#654E3A",
    Candle: "#F2B642",
    Tablecloth: "#6A9CE1",
  },



  Brown1: "#3D2E18",
  Brown2: "#574123",
  Brown3: "#70542D",
  Brown4: "#8A6737",

  Hay1: "#3D3405",
  Hay2: "#695908",
  Hay3: "#947D0C",
  Hay4: "#C3A510",

  BurntGreen1: "#3D3D18",
  BurntGreen2: "#575723",
  BurntGreen3: "#70702D",
  BurntGreen4: "#8A8A37",

  GrassGreen1: "#2E3D18",
  GrassGreen2: "#415723",
  GrassGreen3: "#54702D",
  GrassGreen4: "#678A37",

  LushGreen1: "#1B3D18",
  LushGreen2: "#265723",
  LushGreen3: "#31702D",
  LushGreen4: "#3D8A37",

  BorealGreen1: "#183D27",
  BorealGreen2: "#235737",
  BorealGreen3: "#2D7047",
  BorealGreen4: "#378A57",

  TealBlue1: "#013D35",
  TealBlue2: "#02574B",
  TealBlue3: "#027062",
  TealBlue4: "#038A78",

  AquaBlue1: "#14383D",
  AquaBlue2: "#1C4F57",
  AquaBlue3: "#246670",
  AquaBlue4: "#2C7D8A",

  Carbonate1: "#2E2922",
  Carbonate2: "#3D362D",
  Carbonate3: "#4D4438",
  Carbonate4: "#615647",
  Slate1: "#2E2A29",
  Slate2: "#403A39",
  Slate3: "#524B49",
  Slate4: "#665D5C",
  Slate1Muted: "#2E2A29",
  Slate2Muted: "#403A39",
  Slate3Muted: "#524B49",
  Slate4Muted: "#665D5C",
  Limestone1: "#2C2E2D",
  Limestone2: "#3D403E",
  Limestone3: "#4E5250",
  Limestone4: "#626664",
  Limestone1Muted: "#2C2E2D",
  Limestone2Muted: "#3D403E",
  Limestone3Muted: "#4E5250",
  Limestone4Muted: "#626664"
}

export default Palette;
